'use client';

import { useAuth } from '@clerk/clerk-react';
import type React from 'react';
import { useEffect, useState } from 'react';
import { AuthContext } from './AuthContextType';

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isSignedIn, isLoaded } = useAuth();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isLoaded) {
      setIsAuthenticated(isSignedIn || false);
      setIsLoading(false);
    }
  }, [isSignedIn, isLoaded]);

  return <AuthContext.Provider value={{ isAuthenticated, isLoading }}>{children}</AuthContext.Provider>;
};
